import { useAppDispatch } from '../features';
import { apiSlice } from '../features/slice/api-slice';

export const useInvalidateTag = () => {
    const dispatch = useAppDispatch();

    const invalidateTag = (tag: string) => {
        dispatch(apiSlice.util.invalidateTags([tag]));
    };

    return { invalidateTag };
};
